var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "download-list" },
    _vm._l(_vm.media, function(media, index) {
      return _c(
        "a",
        {
          key: index,
          staticClass: "download",
          attrs: { href: media.path, target: "_blank", rel: "noopener" }
        },
        [
          _c("div", { staticClass: "title" }, [
            _c("span", { domProps: { innerHTML: _vm._s(_vm.svg("file")) } }),
            _vm._v("\n            " + _vm._s(media.name) + "\n        ")
          ]),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._s(_vm.svg("download")) } })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }